import { privateApi, createPrivateClient } from './api';
import type { PendingPixRecharge } from '../types/recharge';

// Cliente sem interceptor de 401 — evita que uma falha nesse endpoint
// de analytics dispare o handler de sessão expirada e cause re-renders.
const analyticsClient = createPrivateClient();

// Cliente sem interceptor de 401 — evita que um 401 no polling do QR code
// dispare o handler de sessão expirada durante uma transação em andamento.
const pollingClient = createPrivateClient();

const PIX_ORDER_TIMEOUT_MS = 3000;

const pixRechargeService = {
  createPixRecharge: (
    msisdn: string,
    rechargeValueId: number,
    targetMsisdn: string | null,
  ) =>
    privateApi.post(`/customers/${msisdn}/recharges/pix`, {
      rechargeValueId,
      msisdnRecebedor: targetMsisdn,
    }),

  getPixToken: (msisdn: string, transactionId: string) =>
    pollingClient.get(`/customers/${msisdn}/recharges/pix/${transactionId}`),

  sendPixRechargeIntention: (msisdn: string) =>
    analyticsClient.post(`/pix/${msisdn}/rechargeIntention`, null, {
      headers: { mode: 'async' },
    }),

  // Recarga Pix gerada e ainda não paga. 200 = pendência; 404 = sem pendência.
  getPendingPixRecharge: (msisdn: string) =>
    privateApi.get<PendingPixRecharge>(`/customers/${msisdn}/orders`, {
      params: { status: 'waiting_for_payment' },
    }),

  // Mesma rota, para ler a validade do Pix recém-gerado. Roda entre o QR code
  // pronto e a tela de pagamento, com o usuário esperando: prazo curto e sem
  // retry, e sem o interceptor de 401 — quem chama cai numa janela padrão.
  getPixOrder: (msisdn: string) =>
    pollingClient.get<PendingPixRecharge>(`/customers/${msisdn}/orders`, {
      params: { status: 'waiting_for_payment' },
      timeout: PIX_ORDER_TIMEOUT_MS,
      'axios-retry': { retries: 0 },
    }),
};

export default pixRechargeService;
